module.exports = __webpack_public_path__ + "img/purchaseData-active.78794bbe.svg";